import type { HomepageSection, HomepageSectionResponse } from './homepage-sections';

/** Shared public endpoint for homepage and catalogue decorations, never private prices. */
export async function fetchPublicHomepageSection(
  section: HomepageSection,
  locale: string,
  signal?: AbortSignal,
): Promise<HomepageSectionResponse> {
  const response = await fetch(
    `/api/homepage-section?${new URLSearchParams({ locale, section })}`,
    { signal },
  );
  if (!response.ok) throw new Error('Storefront section unavailable.');
  const result = (await response.json()) as HomepageSectionResponse;
  if (!result || result.section !== section || !Array.isArray(result.data))
    throw new Error('Invalid storefront section.');
  return result;
}
